module.exports = __webpack_public_path__ + "static/media/endFrame.95510537.png";